/**
 * Variant Selector Fix for Shopify - VERSIÓN 2
 * Solución para cuando data-variant-json no existe
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelector);
  } else {
    initVariantSelector();
  }

  function initVariantSelector() {
    const variantInputs = document.querySelectorAll('[data-variant-input]');
    const productSelect = document.querySelector('[data-product-select]');
    
    if (!variantInputs.length || !productSelect) return;

    const productHandle = document.querySelector('[data-section-type="product"]')?.getAttribute('data-product-handle');
    
    if (!productHandle) return;

    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const variants = product.variants;
        variantInputs.forEach(input => {
          input.addEventListener('change', () => handleVariantChange(variants, product.title));
        });
      })
      .catch(error => console.error('Error loading product data:', error));

    function handleVariantChange(variants, productTitle) {
      const selectedOptions = getSelectedOptions();
      const matchedVariant = findMatchingVariant(variants, selectedOptions);

      if (matchedVariant) {
        updateVariantId(matchedVariant);
        updatePrice(matchedVariant);
        updateButton(matchedVariant);
        updateSKU(matchedVariant);
        updateURL(matchedVariant);
        updateTitle(matchedVariant, productTitle);
      }
    }

    function updateTitle(variant, productTitle) {
      const titles = document.querySelectorAll('.product-single__title');
      if (!titles.length) return;

      const parts = [productTitle];
      if (variant.option1) parts.push(variant.option1);
      if (variant.option2) parts.push(variant.option2);

      const text = parts.join(' | ');
      titles.forEach(title => title.textContent = text);
    }

    function getSelectedOptions() {
      const options = {};
      
      document.querySelectorAll('[data-variant-input]:checked').forEach(input => {
        options[input.getAttribute('data-index')] = input.value;
      });

      document.querySelectorAll('select[data-variant-input]').forEach(select => {
        options[select.getAttribute('data-index')] = select.value;
      });

      return options;
    }

    function findMatchingVariant(variants, selectedOptions) {
      return variants.find(variant => {
        const match1 = variant.option1 === selectedOptions['option1'];
        const match2 = !selectedOptions['option2'] || variant.option2 === selectedOptions['option2'];
        const match3 = !selectedOptions['option3'] || variant.option3 === selectedOptions['option3'];
        return match1 && match2 && match3;
      });
    }

    function updateVariantId(variant) {
      productSelect.value = variant.id;
      productSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updatePrice(variant) {
      const productPrice = document.querySelector('[data-product-price]');
      const comparePrice = document.querySelector('[data-compare-price]');
      const comparePriceWrap = document.querySelector('[data-product-price-wrap]');
      const savePrice = document.querySelector('[data-save-price]');

      if (!productPrice) return;

      productPrice.innerHTML = formatMoney(variant.price);

      if (comparePrice && comparePriceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.innerHTML = formatMoney(variant.compare_at_price);
          comparePriceWrap.classList.remove('hide');
          productPrice.classList.add('on-sale');
        } else {
          comparePriceWrap.classList.add('hide');
          productPrice.classList.remove('on-sale');
        }
      }

      if (savePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const saved = variant.compare_at_price - variant.price;
          savePrice.innerHTML = 'Save ' + formatMoney(saved);
          savePrice.classList.remove('hide');
        } else {
          savePrice.classList.add('hide');
        }
      }

      const unitPriceWrapper = document.querySelector('[data-unit-price-wrapper]');
      const unitPrice = document.querySelector('[data-unit-price]');
      const unitBase = document.querySelector('[data-unit-base]');

      if (unitPriceWrapper && unitPrice && unitBase) {
        if (variant.unit_price_measurement) {
          unitPrice.innerHTML = formatMoney(variant.unit_price);
          let baseUnit = '';
          if (variant.unit_price_measurement.reference_value !== 1) {
            baseUnit = variant.unit_price_measurement.reference_value;
          }
          baseUnit += variant.unit_price_measurement.reference_unit;
          unitBase.textContent = baseUnit;
          unitPriceWrapper.classList.remove('hide');
        } else {
          unitPriceWrapper.classList.add('hide');
        }
      }
    }

    function updateButton(variant) {
      const addToCartButton = document.querySelector('[data-add-to-cart]');
      const addToCartText = document.querySelector('[data-add-to-cart-text]');
      
      if (!addToCartButton || !addToCartText) return;

      const defaultText = addToCartText.getAttribute('data-default-text') || 'Add to Cart';

      if (variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('disabled');
        addToCartText.textContent = defaultText;
      } else {
        addToCartButton.disabled = true;
        addToCartButton.classList.add('disabled');
        addToCartText.textContent = 'Sold Out';
      }
    }

    function updateSKU(variant) {
      const skuElement = document.querySelector('[data-sku-id]');
      const skuContainer = document.querySelector('[data-sku]');
      
      if (!skuElement) return;
      
      if (variant.sku) {
        skuElement.textContent = variant.sku;
        if (skuContainer) skuContainer.classList.remove('hide');
      } else {
        if (skuContainer) skuContainer.classList.add('hide');
      }
    }

    function updateURL(variant) {
      const productSection = document.querySelector('[data-section-type="product"]');
      if (!productSection) return;
      
      if (productSection.getAttribute('data-history') === 'true' && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    function formatMoney(cents) {
      const moneyFormat = window.theme && window.theme.moneyFormat 
        ? window.theme.moneyFormat 
        : '${{amount}}';
      
      if (typeof cents === 'string') cents = cents.replace('.', '');
      
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? (decimal + parts[1]) : '';
        return dollarsAmount + centsAmount;
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      }

      return moneyFormat.replace(placeholderRegex, value);
    }
  }
})();